import { Product, ProductBackend } from '../../product/product';
import { Resume, ResumeBackend } from '../../resume/resume';
import { convertResumeJsonToMarkdown } from '../resume/get-resume-content.prompt';

export function getSecondMessagePrompt(
  resume: Resume | ResumeBackend,
  product: Product | ProductBackend,
  instruction: string
) {
  const customerInfo = convertResumeJsonToMarkdown(resume.subData.content as any, true);

  return `
Craft a personalized and engaging invite message based on the customer info provided. Follow the template structure but adapt it to the specific customer's background and potential needs.

    <CUSTOMER_INFO>
    ${customerInfo}
    </CUSTOMER_INFO>

    <PRODUCT_INFO>
    Product Name:
    ${product?.title}

    Product Description:
    ${product?.description}
    </PRODUCT_INFO>

Research the companies the prospect has worked at.

Gather the following information:
0. Customer Info
- The First Name of the prospect

1. Current Compnay and Role
   - The industry of the company
   - The size of the company

2. Prospect's Pain Points
The typical concerns or challenges the prospect is facing as the role in the company, in the industry.
Output in bullet points. Be concise, direct.

3. Past Experience and Roles.
- Include an oneliner summarization for each of the companies the prospect has worked at. Include the following details:
    - Including The industry of the company and The size of the company.
    - The role
    - The years of the prospects worked.
Output in one line for each company.

4. Personalized Message
Create a direct, concise, personalized message to the prospect attending to the First Name of the prospect for a conversation to improve their sales process.
The message should not include template "[First Name]" in the output. Use specific values of First Name if it exists in the customer info.
The message should take into account the paintpoints and current and past experience but don't explicitly mention them.
The message should mention the relevant product highlights extract from <PRODUCT_INFO> that would be of interest to the prospect.
Avoid using generic words such as "current role" or "past experience" or "some of the challenges" or "strong background in software engineering and leadership" in the message.
Always use specific details from the paintpoints and current and past experience from information gathered in step 1,2 and 3.
Do not add closing.

Follow the instructions below to craft the "First Message" for the prospect.
${instruction}


Output Personalized "First Message". Do not ontput other sections. Outout in plain text format. Do not output markdown for URLs.
  `;
}
